import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sinu ON24 raha

  <span style="color:#85c1dc;">**FI:**</span>
  Sinun ON24-rahasi

  <span style="color:#85c1dc;">**RU:**</span>
  Ваши ON24 деньги
*/
/* @__NO_SIDE_EFFECTS__ */
const m1465 = msg(
  mf`Sinu ON24 raha`,
  mf`Sinun ON24-rahasi`,
  mf`Ваши ON24 деньги`,
)

export { m1465 as 'w.basket.summary.customer_credits' }